<div class="page-no-auth-content">
  <h2 style="font-size: 4em;color: #fff;"><i class="fa fa-flag" aria-hidden="true"></i></h2>
  <h3>Solicitud no permitida!.</h3>
  <h4>Actualmente existe una sesión ya iniciada en el sistema, <br><br>
    por motivos de seguridad sólo se acepta una (1) sesión activa por usuario.</h4>
  <a [routerLink]="['/ingreso']">
    Volver al login
  </a>
</div>
